export const TOUR_ADD_REVIEW_DETAIL_SUCCESS = "TOUR_ADD_REVIEW_DETAIL_SUCCESS";
export const TOUR_ADD_REVIEW_DETAIL_ERROR = "TOUR_ADD_REVIEW_DETAIL_ERROR";